import LargePaidIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/paid';
import LargePriceTagIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/price-tag';
import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { useMBDContext } from '../common/MBD/useMBDContext';

import STYLES from './BarChartWithInfoSnippets.module.scss';

export type InfoSnippetItem = {
  icon: 'priceTag' | 'paid';
  label: string;
  value: string;
  url?: string;
};

const snippetIconMap: Record<InfoSnippetItem['icon'], React.ComponentType> = {
  priceTag: LargePriceTagIcon,
  paid: LargePaidIcon,
};

const InfoSnippet = ({ snippet }: { snippet: InfoSnippetItem }) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const IconComponent = snippetIconMap[snippet.icon];
  const snippetCtaComponentName = `${rawComponentName}_snippet_cta`;

  return (
    <div className={STYLES.InfoSnippet}>
      <div className={STYLES.InfoSnippet__icon}>
        {IconComponent && <IconComponent />}
      </div>
      <BpkText textStyle={TEXT_STYLES.bodyDefault}>{snippet.label}</BpkText>
      {snippet.url ? (
        <BpkLink
          href={snippet.url}
          className={STYLES.InfoSnippet__value}
          data-tracking-element-id={snippetCtaComponentName}
          data-tracking-common-params={buildMBDParam(snippetCtaComponentName)}
        >
          {snippet.value}
        </BpkLink>
      ) : (
        <BpkText
          textStyle={TEXT_STYLES.heading4}
          className={STYLES.InfoSnippet__value}
        >
          {snippet.value}
        </BpkText>
      )}
    </div>
  );
};

export default InfoSnippet;
